import { EXAM_CYCLE_YEAR } from "../config/examCycle";

// Split out of prepQuestions.ts so lightweight consumers (e.g. keyDates.ts) don't
// pull in the ~3,700-line question bank just for exam names/dates.
export type Exam = "ensa" | "ena" | "encg" | "fmp";
export type Level = "facile" | "moyen" | "difficile";

export const EXAM_META: Record<Exam, {
  label: string;
  fullName: string;
  icon: string;
  color: string;
  bg: string;
  border: string;
  duration: string;
  format: string;
  date: string;
  subjects: { key: string; label: string; icon: string }[];
  levels: [string, string, string, string]; // débutant → reçu
}> = {
  ensa: {
    label: "ENSA",
    fullName: "École Nationale des Sciences Appliquées",
    icon: "⚙️",
    color: "from-blue-600 to-blue-800",
    bg: "bg-blue-50",
    border: "border-blue-200",
    duration: "3h (2 épreuves de 1h30)",
    format: "QCM — 20 Maths + 8 Physique-Chimie",
    date: `~22 juillet ${EXAM_CYCLE_YEAR}`,
    subjects: [
      { key: "complexes", label: "Nombres complexes", icon: "🔢" },
      { key: "suites", label: "Suites & Arithmétique", icon: "📈" },
      { key: "analyse", label: "Analyse & Intégrales", icon: "∫" },
      { key: "probabilites", label: "Probabilités", icon: "🎲" },
      { key: "mecanique", label: "Mécanique", icon: "⚡" },
      { key: "electricite", label: "Électricité", icon: "🔌" },
      { key: "optique", label: "Optique & Nucléaire", icon: "💡" },
      { key: "chimie", label: "Chimie", icon: "⚗️" },
    ],
    levels: ["Lycéen", "Candidat", "Postulant", "Reçu"],
  },
  ena: {
    label: "ENA",
    fullName: "École Nationale d'Architecture",
    icon: "🏛️",
    color: "from-amber-600 to-amber-800",
    bg: "bg-amber-50",
    border: "border-amber-200",
    duration: "50 min QCM + 60 min Dessin",
    format: "50 QCM (Géométrie, Art, Culture, Français)",
    date: `~26 juillet ${EXAM_CYCLE_YEAR}`,
    subjects: [
      { key: "geometrie", label: "Géométrie & Échelles", icon: "📐" },
      { key: "art", label: "Art & Architecture", icon: "🎨" },
      { key: "culture", label: "Culture générale", icon: "🌍" },
      { key: "logique", label: "Logique & Français", icon: "🧠" },
    ],
    levels: ["Esquisse", "Concepteur", "Architecte", "Lauréat"],
  },
  encg: {
    label: "ENCG / TAFEM",
    fullName: "École Nationale de Commerce et de Gestion",
    icon: "📊",
    color: "from-emerald-600 to-emerald-800",
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    duration: "2h30",
    format: "~100 QCM (Maths, Économie, Français, Culture)",
    date: `~21 juillet ${EXAM_CYCLE_YEAR}`,
    subjects: [
      { key: "maths", label: "Mathématiques", icon: "🔢" },
      { key: "economie", label: "Économie", icon: "📈" },
      { key: "management", label: "Management", icon: "💼" },
      { key: "francais", label: "Français", icon: "📝" },
      { key: "culture", label: "Culture générale", icon: "🌍" },
    ],
    levels: ["Apprenti", "Gestionnaire", "Manager", "Diplômé"],
  },
  fmp: {
    label: "FMP / Médecine",
    fullName: "Faculté de Médecine et de Pharmacie",
    icon: "🩺",
    color: "from-rose-600 to-rose-800",
    bg: "bg-rose-50",
    border: "border-rose-200",
    duration: "3h30 (4 épreuves)",
    format: "SVT + Physique + Chimie + Maths",
    date: `~8 août ${EXAM_CYCLE_YEAR}`,
    subjects: [
      { key: "svt_energie", label: "Énergie cellulaire", icon: "⚡" },
      { key: "svt_muscle", label: "Muscle & Contraction", icon: "💪" },
      { key: "svt_genetique", label: "ADN & Génétique", icon: "🧬" },
      { key: "chimie_redox", label: "Redox & Cinétique", icon: "⚗️" },
      { key: "chimie_acide", label: "Acido-basique", icon: "🔬" },
      { key: "chimie_organique", label: "Chimie organique", icon: "🧪" },
      { key: "physique_ondes", label: "Ondes", icon: "〰️" },
      { key: "physique_nuc", label: "Physique nucléaire", icon: "☢️" },
      { key: "physique_elec", label: "Électricité", icon: "🔌" },
      { key: "maths_analyse", label: "Analyse & Calcul", icon: "∫" },
      { key: "maths_proba", label: "Probabilités", icon: "🎲" },
    ],
    levels: ["Candidat", "Médecin stagiaire", "Interne", "Reçu(e)"],
  },
};
